var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_12519_21309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.4422 11.5517C18.7223 10.8315 17.5678 10.8036 16.8139 11.4883L14.2721 13.7966C13.9796 13.1202 13.306 12.6456 12.5235 12.6456H9.32359C8.55152 11.8604 7.49695 11.4152 6.38922 11.4152C5.57609 11.4152 4.79176 11.6554 4.1266 12.0936C3.96 11.3416 3.28836 10.7773 2.48695 10.7773H0V19.419H2.48699C3.14621 19.419 3.71766 19.0371 3.99246 18.4831L6.76148 19.419H14.0784L19.4174 14.2701C19.7884 13.9123 19.9952 13.4315 20 12.9161C20.0046 12.4008 19.8066 11.9162 19.4422 11.5517ZM2.9948 17.7393C2.9948 18.0193 2.76699 18.2471 2.48699 18.2471H1.17188V11.9492H2.48699C2.76699 11.9492 2.9948 12.177 2.9948 12.457V17.7393ZM18.6039 13.4266L13.6054 18.2471H6.95414L4.16664 17.305V13.6018C4.72711 12.9569 5.53609 12.5871 6.38922 12.5871C7.24769 12.5871 8.06164 12.9612 8.6225 13.6136L8.79785 13.8175H12.5235C12.9273 13.8175 13.2559 14.1461 13.2559 14.55C13.2559 14.9538 12.9273 15.2824 12.5235 15.2824H9.18039V16.4543H12.5235C13.2525 16.4543 13.8868 16.0423 14.2068 15.4391L17.6017 12.3559C17.8919 12.0923 18.3362 12.103 18.6134 12.3803C18.7536 12.5205 18.8299 12.7071 18.8281 12.9054C18.8263 13.1038 18.7466 13.2889 18.6039 13.4266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.843 11.168C14.7616 11.168 17.136 8.79355 17.136 5.875C17.136 2.95645 14.7616 0.582031 11.843 0.582031C8.92446 0.582031 6.55005 2.95645 6.55005 5.875C6.55005 8.79355 8.92446 11.168 11.843 11.168ZM11.843 1.75391C14.1154 1.75391 15.9641 3.60262 15.9641 5.875C15.9641 8.14738 14.1154 9.99609 11.843 9.99609C9.57063 9.99609 7.72192 8.14738 7.72192 5.875C7.72192 3.60262 9.57063 1.75391 11.843 1.75391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.825 3.91602C12.2007 3.91602 12.5064 4.22168 12.5064 4.59738C12.5064 4.97309 12.2007 5.27875 11.825 5.27875H11.2391V7.09309H12.411V6.3557C13.1466 6.10992 13.6783 5.41457 13.6783 4.59738C13.6783 3.57551 12.8469 2.74414 11.825 2.74414C10.8032 2.74414 9.9718 3.57551 9.9718 4.59738H11.1437C11.1437 4.22168 11.4493 3.91602 11.825 3.91602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.2511 7.73633H12.423V8.9082H11.2511V7.73633Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_21309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.f919ae486fc0fa9f91ea62c85f8af7aa.svg";
export { ForwardRef as ReactComponent };